// extracted by mini-css-extract-plugin
export default {"main":"marketChart_main__XcCSc"};